import { useContext, useState } from "react";
import InputPro from "../../components/ui/InputPro";
import PasswordInputPro from "../../components/ui/PasswordInput";
import SelectSimple from "../../components/ui/Select";
import Button from "../../components/ui/Button";

import { checkEmail, checkUsername } from "../../api/auth";
import { LanguageContext } from "../../context/LanguageContext";

const COUNTRIES = [
    { value: "", label: "" },
  { value: "MA", label: "Morocco" },
  { value: "DZ", label: "Algeria" },
  { value: "TN", label: "Tunisia" },
  { value: "LY", label: "Libya" },
  { value: "EG", label: "Egypt" },
];

export default function StepUser({
  userData,
  updateUserData,
  errors,
  updateErrors,
  role,
  setRole,
  nextStep,
}) {
  const { t } = useContext(LanguageContext);
  const [checking, setChecking] = useState(false);

  /* =========================
      HANDLER
  ========================= */
  const handleChange = async (e) => {
    const { name, value } = e.target;

    updateUserData({ [name]: value });
    updateErrors({ [name]: "" });

    // EMAIL CHECK
    if (name === "email" && value.trim()) {
      try {
        setChecking(true);
        const res = await checkEmail({ email: value });
        if (res.data?.exists) {
          updateErrors({ email: t("auth.email_taken") });
        }
      } finally {
        setChecking(false);
      }
    }

    // USERNAME CHECK
    if (name === "username" && value.trim()) {
      try {
        setChecking(true);
        const res = await checkUsername({ username: value });
        if (res.data?.exists) {
          updateErrors({ username: t("auth.username_taken") });
        }
      } finally {
        setChecking(false);
      }
    }
  };

  /* =========================
      VALIDATION
  ========================= */
  const validateBeforeNext = () => {
    let ok = true;

    const requiredFields = ["email", "username", "password", "country"];
    requiredFields.forEach((field) => {
      if (!userData[field]) {
        updateErrors({ [field]: t("auth.required") });
        ok = false;
      }
    });

    // Email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;
    if (userData.email && !emailRegex.test(userData.email)) {
      updateErrors({ email: t("auth.email_invalid") });
      ok = false;
    }

    // Password minimum rules
    if (userData.password && userData.password.length < 8) {
      updateErrors({ password: t("auth.password_min") });
      ok = false;
    }

    if (errors.email || errors.username || errors.password) ok = false;
    if (checking) ok = false;

    if (ok) nextStep();
  };

  return (
    <div className="space-y-6">
      {/* TITLE */}
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
        {t("auth.accountInfos")}
      </h2>

      {/* EMAIL */}
      <InputPro
        label={t("auth.email")}
        name="email"
        type="email"
        required
        value={userData.email || ""}
        error={errors.email}
        onChange={handleChange}
      />

      {/* USERNAME */}
      <InputPro
        label={t("auth.username")}
        name="username"
        required
        value={userData.username || ""}
        error={errors.username}
        onChange={handleChange}
      />

      {/* PASSWORD */}
      <PasswordInputPro
        label={t("auth.password")}
        name="password"
        required
        value={userData.password || ""}
        error={errors.password}
        onChange={handleChange}
      />

      {/* COUNTRY */}
      <SelectSimple
        label={t("auth.country")}
        name="country"
        required
        
        value={userData.country || ""}
        onChange={handleChange}
        options={COUNTRIES}
        error={errors.country}
      />

      {/* ROLE */}
      <SelectSimple
        label={t("auth.account_type")}
        name="role"
        required
        value={role}
        onChange={(e) => setRole(e.target.value)}
        options={[
          { value: "STORE", label: t("auth.role_store") },
          { value: "AGENCY_OWNER", label: t("auth.role_agency_owner") },
          { value: "AGENCY_AGENT", label: t("auth.role_agency_agent") },
        ]}
      />

      {/* ACTION */}
      <Button
        onClick={validateBeforeNext}
        loading={checking}
        className="mt-4"
      >
        {t("common.next") || "Next"}
      </Button>
    </div>
  );
}
